import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { Location } from '@angular/common';
import { UntypedFormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { IntervalService } from '@app/_components/task/interval';
import { AlertService } from '@app/_services';
import { ApiResponse } from '@app/_models';
import { debounceTime } from 'rxjs/operators';





@Component({
    selector: 'app-interval-select',
    templateUrl: './interval.component.html',
    styleUrls: ['./interval.component.css'],
    standalone: false
})
export class IntervalComponent implements OnInit, OnChanges
{

	@Output() messageEvent = new EventEmitter<string>();
	@Input() taskId: number;
	@Input() intervalType: number;
	@Input() interval;

	intervalId: number;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private intervalService: IntervalService,
		private alertService: AlertService,
		private location: Location,
		private formBuilder: UntypedFormBuilder) { }

	// structure
	subscription: Subscription;
	routerLocation = this.location;

	offset = new Date().getTimezoneOffset() / 60;


	// data
	intervalApiResponse: ApiResponse;
	intervalApi;


	// forms
	intervalSelectForm: UntypedFormGroup;
	formLoading = false;
	formAction: String;
	formLabels = [];
	formReadOnly = false;

	positionInIntervals = [
		{ value: 1, name: 'first' },
		{ value: 2, name: 'second' },
		{ value: 3, name: 'third' },
		{ value: 4, name: 'fourth' },
		{ value: 5, name: 'last' }
	];
	days = [
		{ value: 1, name: 'Monday' },
		{ value: 2, name: 'Tuesday' },
		{ value: 3, name: 'Wednesday' },
		{ value: 4, name: 'Thursday' },
		{ value: 5, name: 'Friday' },
		{ value: 6, name: 'Saturday' },
		{ value: 7, name: 'Sunday' }
	];

	months = [
		{ value: 1, name: 'January' },
		{ value: 2, name: 'February' },
		{ value: 3, name: 'March' },
		{ value: 4, name: 'April' },
		{ value: 5, name: 'May' },
		{ value: 6, name: 'June' },
		{ value: 7, name: 'July' },
		{ value: 8, name: 'August' },
		{ value: 9, name: 'September' },
		{ value: 10, name: 'October' },
		{ value: 11, name: 'November' },
		{ value: 12, name: 'December' }
	];

	timeZones = [
		{ value: 'US/Hawaii', name: 'HST' },
		{ value: 'US/Pacific', name: 'PST' },
		{ value: 'US/Mountain', name: 'MST' },
		{ value: 'US/Central', name: 'CST' },
		{ value: 'US/Eastern', name: 'EST' },
	];


	time = [
		{ value: '12:00 AM', name: '12:00 AM' },
		{ value: '12:15 AM', name: '12:15 AM' },
		{ value: '12:30 AM', name: '12:30 AM' },
		{ value: '12:45 AM', name: '12:45 AM' },
		{ value: '1:00 AM', name: '1:00 AM' },
		{ value: '1:15 AM', name: '1:15 AM' },
		{ value: '1:30 AM', name: '1:30 AM' },
		{ value: '1:45 AM', name: '1:45 AM' },
		{ value: '2:00 AM', name: '2:00 AM' },
		{ value: '2:15 AM', name: '2:15 AM' },
		{ value: '2:30 AM', name: '2:30 AM' },
		{ value: '2:45 AM', name: '2:45 AM' },
		{ value: '3:00 AM', name: '3:00 AM' },
		{ value: '3:15 AM', name: '3:15 AM' },
		{ value: '3:30 AM', name: '3:30 AM' },
		{ value: '3:45 AM', name: '3:45 AM' },
		{ value: '4:00 AM', name: '4:00 AM' },
		{ value: '4:15 AM', name: '4:15 AM' },
		{ value: '4:30 AM', name: '4:30 AM' },
		{ value: '4:45 AM', name: '4:45 AM' },
		{ value: '5:00 AM', name: '5:00 AM' },
		{ value: '5:15 AM', name: '5:15 AM' },
		{ value: '5:30 AM', name: '5:30 AM' },
		{ value: '5:45 AM', name: '5:45 AM' },
		{ value: '6:00 AM', name: '6:00 AM' },
		{ value: '6:15 AM', name: '6:15 AM' },
		{ value: '6:30 AM', name: '6:30 AM' },
		{ value: '6:45 AM', name: '6:45 AM' },
		{ value: '7:00 AM', name: '7:00 AM' },
		{ value: '7:15 AM', name: '7:15 AM' },
		{ value: '7:30 AM', name: '7:30 AM' },
		{ value: '7:45 AM', name: '7:45 AM' },
		{ value: '8:00 AM', name: '8:00 AM' },
		{ value: '8:15 AM', name: '8:15 AM' },
		{ value: '8:30 AM', name: '8:30 AM' },
		{ value: '8:45 AM', name: '8:45 AM' },
		{ value: '9:00 AM', name: '9:00 AM' },
		{ value: '9:15 AM', name: '9:15 AM' },
		{ value: '9:30 AM', name: '9:30 AM' },
		{ value: '9:45 AM', name: '9:45 AM' },
		{ value: '10:00 AM', name: '10:00 AM' },
		{ value: '10:15 AM', name: '10:15 AM' },
		{ value: '10:30 AM', name: '10:30 AM' },
		{ value: '10:45 AM', name: '10:45 AM' },
		{ value: '11:00 AM', name: '11:00 AM' },
		{ value: '11:15 AM', name: '11:15 AM' },
		{ value: '11:30 AM', name: '11:30 AM' },
		{ value: '11:45 AM', name: '11:45 AM' },
		{ value: '12:00 PM', name: '12:00 PM' },
		{ value: '12:15 PM', name: '12:15 PM' },
		{ value: '12:30 PM', name: '12:30 PM' },
		{ value: '12:45 PM', name: '12:45 PM' },
		{ value: '1:00 PM', name: '1:00 PM' },
		{ value: '1:15 PM', name: '1:15 PM' },
		{ value: '1:30 PM', name: '1:30 PM' },
		{ value: '1:45 PM', name: '1:45 PM' },
		{ value: '2:00 PM', name: '2:00 PM' },
		{ value: '2:15 PM', name: '2:15 PM' },
		{ value: '2:30 PM', name: '2:30 PM' },
		{ value: '2:45 PM', name: '2:45 PM' },
		{ value: '3:00 PM', name: '3:00 PM' },
		{ value: '3:15 PM', name: '3:15 PM' },
		{ value: '3:30 PM', name: '3:30 PM' },
		{ value: '3:45 PM', name: '3:45 PM' },
		{ value: '4:00 PM', name: '4:00 PM' },
		{ value: '4:15 PM', name: '4:15 PM' },
		{ value: '4:30 PM', name: '4:30 PM' },
		{ value: '4:45 PM', name: '4:45 PM' },
		{ value: '5:00 PM', name: '5:00 PM' },
		{ value: '5:15 PM', name: '5:15 PM' },
		{ value: '5:30 PM', name: '5:30 PM' },
		{ value: '5:45 PM', name: '5:45 PM' },
		{ value: '6:00 PM', name: '6:00 PM' },
		{ value: '6:15 PM', name: '6:15 PM' },
		{ value: '6:30 PM', name: '6:30 PM' },
		{ value: '6:45 PM', name: '6:45 PM' },
		{ value: '7:00 PM', name: '7:00 PM' },
		{ value: '7:15 PM', name: '7:15 PM' },
		{ value: '7:30 PM', name: '7:30 PM' },
		{ value: '7:45 PM', name: '7:45 PM' },
		{ value: '8:00 PM', name: '8:00 PM' },
		{ value: '8:15 PM', name: '8:15 PM' },
		{ value: '8:30 PM', name: '8:30 PM' },
		{ value: '8:45 PM', name: '8:45 PM' },
		{ value: '9:00 PM', name: '9:00 PM' },
		{ value: '9:15 PM', name: '9:15 PM' },
		{ value: '9:30 PM', name: '9:30 PM' },
		{ value: '9:45 PM', name: '9:45 PM' },
		{ value: '10:00 PM', name: '10:00 PM' },
		{ value: '10:15 PM', name: '10:15 PM' },
		{ value: '10:30 PM', name: '10:30 PM' },
		{ value: '10:45 PM', name: '10:45 PM' },
		{ value: '11:00 PM', name: '11:00 PM' },
		{ value: '11:15 PM', name: '11:15 PM' },
		{ value: '11:30 PM', name: '11:30 PM' },
		{ value: '11:45 PM', name: '11:45 PM' }
	];



	// validation

	validationMessages = {
		'isRecurring': [],
		'intervalType': [],
		'intervalEndDate': [],
		'frequency': [],
		'frequencySkip': [],
		'maxIntervals': [],
		'positionInInterval': [],
		'startTime': [],
		'endTime': [],
		'timeZone': [],
		'dayOfWeek': [],
		'weekOfMonth': [],
		'dayOfMonth': [],
		'dateOfMonth': [],
		'monthOfYear': [],
		'excludeexcludeWeekends': [],
		'monthType': [],
		'yearType': [],
		'mon': [],
		'tue': [],
		'wed': [],
		'thu': [],
		'fri': [],
		'sat': [],
		'sun': []
	};


	ngOnInit()
	{
		this.formReadOnly = false;
		this.formBuild();

		// if we have previously created intervals to pass...
		if (!!this.interval)
		{
			this.intervalSelectForm.patchValue(this.interval);
			this.intervalId = this.interval.intervalId;
		}

		this.intervalSelectForm.valueChanges.pipe(debounceTime(3000)).subscribe(formData =>
		{
			// added
			if (!!this.intervalSelectForm && this.intervalSelectForm.dirty)
			{

				if (this.intervalId == null)
				{
					console.log('Interval: Saving...' + JSON.stringify(formData));
					this.intervalSelectForm.markAsPristine(); // prevents update loop
					this.formAdd();
				}
				else
				{
					console.log('Interval: Updating...' + JSON.stringify(formData));
					this.intervalSelectForm.markAsPristine(); // prevents update loop
					this.formUpdate();
				}
			}
			else
			{
				console.log('INTERVAL DENIED ADD OR UPDATE: Form:' + !!this.intervalSelectForm + ' FormLoading:' + this.formLoading + ' Dirty:' + this.intervalSelectForm.dirty);
			}
		});
	}





	formBuild()
	{
		/**
				   *
				   *
				   *
				   * FORM
				   *
				   */

		this.intervalSelectForm = this.formBuilder.group({

			intervalId: [this.intervalId],
			taskId: [this.taskId, Validators.required],
			isRecurring: [],
			intervalType: [this.intervalType],
			intervalEndDate: [],
			frequency: [],
			frequencySkip: [],
			maxIntervals: [],
			positionInInterval: [],
			startTime: ['12:00 PM'],
			endTime: ['12:00 PM'],
			timeZone: ['US/Pacific'],
			dayOfWeek: [],
			weekOfMonth: [],
			dayOfMonth: [],
			dateOfMonth: [],
			monthOfYear: [],
			excludeWeekends: [],
			monthType: [],
			yearType: [],
			mon: [],
			tue: [],
			wed: [],
			thu: [],
			fri: [],
			sat: [],
			sun: []
		});
	}

	formAdd()
	{
		try
		{
			// stop here if form is invalid
			if (this.intervalSelectForm.invalid)
			{
				console.log('interval-NO BUENO FORM');
				return;
			}

			this.formLoading = true;

			this.intervalService.add(this.intervalSelectForm.value)
				.subscribe(
					res =>
					{
						console.log('interval-Add SUCCESS: ' + JSON.stringify(res));
						this.intervalApiResponse = res;
						this.intervalApi = res.data.interval;
						this.intervalId = this.intervalApi.intervalId;
						this.intervalSelectForm.patchValue(this.intervalApi);
						this.alertService.success(res, false);
					},
					err =>
					{
						console.log('interval-Add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error)
		{
			this.alertService.error(error);
		}
	}

	formUpdate()
	{
		try
		{
			// stop here if form is invalid
			if (this.intervalSelectForm.invalid)
			{
				return;
			}

			this.formLoading = true;
			this.intervalService.update(this.intervalSelectForm.value)
				.subscribe(
					res =>
					{
						console.log('interval-Update SUCCESS: ' + JSON.stringify(res));
						this.intervalApiResponse = res;
						this.intervalApi = res.data.interval;
						this.intervalId = this.intervalApi.intervalId;
						this.intervalSelectForm.patchValue(this.intervalApi);
						this.alertService.success(res, false);
					},
					err =>
					{
						console.log('interval-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error)
		{
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}
	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no taskId.  This sets the taskId when add is successful.
		if (this.intervalSelectForm !== undefined)
		{
			this.intervalSelectForm.patchValue({ taskId: this.taskId });
		}
	}
}
